module.exports = __webpack_public_path__ + "img/LOGO.7d3b1b79.png";